/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Avatar, Skeleton } from '@coursera/cds-core';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import type { SourceCoursePartners } from 'bundles/common/lms-authoring/types/SourceCoursePartners';

const styles = {
  logo: css`
    background-color: var(--cds-color-neutral-background-primary);
    margin-right: var(--cds-spacing-50);

    img {
      vertical-align: baseline;
    }
  `,
  loadingLogo: css`
    padding: 3px;

    > * {
      border-radius: 4px;
    }
  `,
};

export const EmbeddedPartnerLogoSkeleton: React.FC = () => (
  <div css={[styles.logo, styles.loadingLogo]}>
    <Skeleton variant="rect" height={24} width={24} />
  </div>
);

type Props = {
  partners: SourceCoursePartners;
  className?: string;
};

const EmbeddedPartnerLogo: React.FC<Props> = ({ partners, className }) => {
  const multiplePartners = partners.length > 1;

  return (
    <React.Fragment>
      {partners.map((partner) => (
        <TooltipWrapper
          show={multiplePartners}
          key={partner.id}
          placement="bottom"
          delayShow={100}
          tooltipId={'SourcePartnerInfo' + partner.name}
          message={partner.name}
          className={className}
        >
          <div>
            <Avatar
              variant="organization"
              size={24}
              showBorder={true}
              imgProps={{
                src: partner.squareLogo || undefined,
              }}
              aria-hidden
              data-testid="partner-logo"
              css={styles.logo}
            />
          </div>
        </TooltipWrapper>
      ))}
    </React.Fragment>
  );
};

export default EmbeddedPartnerLogo;
